import React, { Component } from 'react';
//import {Alert} from 'react-bootstrap';
import { Table, Jumbotron, Button } from 'react-bootstrap';
//import {Toast} from 'react-bootstrap';
import Menu from '../menu';
import config from '../../config';
//import errores from '../../middleware/errordb'
//import funciones from '../../middleware/funciones';
//import { Header } from 'react-bootstrap/lib/Modal';
import ModalConfirm from '../subcomponent/modalConfirm';

class Listaprecio extends Component {
    constructor(props) {
        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        super(props);
        this.state = {
            data: [],
            empresa: currentCompany,
            tipo: currentUserType,
            mostrarMensaje: false,
            mensaje: ""
        };
    }
    componentDidMount() {
        const datasend = {
            method: 'GET',

            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': this.state.tipo,
            }
        }
        fetch(config.servBackEnd + '/prices/lists', datasend).then(response => response.json())
            .then(data => this.setState({ data }));
    }

    nuevalista = () => {
        const newData = this.state.data;
        const listValid = newData[newData.length - 1];
        if (!listValid || listValid["NOMBRE_LISTA"] !== "") {
            const lastIndex = (newData.length + 1 < 10) ? "0" + (newData.length + 1).toString() : (newData.length + 1).toString();
            ////console.log(lastIndex)
            newData.push({
                ID_EMPRESA: this.state.empresa,
                CODIGO_LISTA_PRECIOS: lastIndex,
                NOMBRE_LISTA: "",
                NEW: true,
                POST: false
            });
            this.setState({ data: newData });
        }
    }

    updateArray = ({ target }) => {
        const { id } = target;
        const { value } = target;
        const { name } = target;
        const dataNew = this.state.data;
        dataNew.forEach(element => {
            if (element.CODIGO_LISTA_PRECIOS === id) {
                element[name] = value.toUpperCase();
                element.CHANGE = true;
            }
        });
        console.log(dataNew);
        this.setState({ data: dataNew });
    }

    guardar = () => {
        event.preventDefault();
        this.setState({ show: true });
    }

    enviarInfo = () => {
        this.setState({show: false});
        const { data } = this.state;
        const datasend = {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'tipo': this.state.tipo,
            }
        };

        data.forEach(element => {
            element.CHANGE = false;
            element.NEW = false;
            element.CONFIRMACION = "";
        });

        this.setState({ data });

        fetch(config.servBackEnd + '/prices/lists/save', datasend).then(response => response.json())
            .then(data => {
                const cData = this.state.data;
                data.forEach(element => {
                    cData.forEach(element2 => {
                        if (element.CODIGO_LISTA_PRECIOS === element2.CODIGO_LISTA_PRECIOS) {
                            element2.ID_LISTA_PRECIOS = element.ID_LISTA_PRECIOS
                            element2.CONFIRMACION = (element.ok) ? 'ok' : 'error';
                        }
                    });
                });
                this.setState({ data: cData });
            });
    }

    checkediva = ({target}) =>{
        const newData = this.state.data;
        for (let index = 0; index < newData.length; index++) {
            const name = 'iva' + index;
            const currentcheck = document.getElementById(name)
            if (name === target.id) {
                newData[index].CHANGE = true
                newData[index].IVA = target.checked;
                currentcheck.checked = target.checked;
            }
        }
        
        this.setState({data:newData});
    }
    checkedPost = ({ target }) => {
        const newData = this.state.data
        for (let index = 0; index < newData.length; index++) {
            const name = 'post' + index;
            const currentcheck = document.getElementById(name)
            if (name === target.id) {
                newData[index].CHANGE = true
                newData[index].POST = true
                currentcheck.checked = target.checked;
            } else {
                if (currentcheck.checked) newData[index].CHANGE = true
                currentcheck.checked = false;
                newData[index].POST = false
            }
        }
        this.setState({data:newData});
    }

    handleClose = () => {
        this.setState({show: false});
    };

    render() {
        const dato = (this.state.data) ? this.state.data : [];
        const mensajeConfirm = "¿Está seguro que desea guardar la lista?";
        //funciones
        const updateArray = this.updateArray;
        const checkedPost = this.checkedPost;
        const checkediva = this.checkediva;
        const style = {
            color: "white",
            backgroundColor: "DodgerBlue",
            padding: "10px",
            fontFamily: "Arial"
        };

        return (
            <div className="contenedor">
                <Menu></Menu>
                <div>
                    <ModalConfirm show={this.state.show} enviarInfo={this.enviarInfo} handleClose={this.handleClose} mensaje={mensajeConfirm}   ></ModalConfirm>
                </div>
                <Jumbotron style={style}>
                    <h1>Modulo Listas de Precios</h1>
                </Jumbotron>
                <Button className="plus m-2" size="sm" onClick={this.nuevalista} variant="outline-primary">Nueva Lista</Button>
                <Button className="plus m-2" size="sm" onClick={this.guardar} variant="outline-primary">Guardar</Button>
                <Table hover responsive size="sm" className="table">
                    <thead>
                        <tr>
                            <th></th>
                            <th>EMPRESA</th>
                            <th>CODIGO</th>
                            <th>NOMBRE</th>
                            <th>CODIGO ERP</th>
                            <th>LISTA POST</th>
                            <th>IVA INCLUIDO</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dato.map(function (currentData, index) {
                            return <tr key={index + "d0"}>
                                <td>{currentData.CONFIRMACION}</td>
                                <td>{currentData.ID_EMPRESA}</td>
                                <td>{currentData.CODIGO_LISTA_PRECIOS}</td>
                                <td><input type="text" name={"NOMBRE_LISTA"} id={currentData.CODIGO_LISTA_PRECIOS} onChange={updateArray} value={currentData.NOMBRE_LISTA} /> </td>
                                <td><input maxLength={4} type="text" name={"ERP_CODE"} id={currentData.CODIGO_LISTA_PRECIOS} onChange={updateArray} value={(currentData.ERP_CODE)?currentData.ERP_CODE:""} /> </td>
                                <td><input type="checkbox" id={'post' + index} checked={currentData.POST} onChange={checkedPost} /> </td>
                                <td><input type="checkbox" id={'iva' + index} checked={currentData.IVA} onChange={checkediva} /> </td>
                                <td><Button disabled={!currentData.ID_LISTA_PRECIOS} size="sm" href={"/listaprecio/actualizar/?" + currentData.ID_LISTA_PRECIOS} variant="outline-primary">Detalle Lista</Button></td>

                            </tr>;
                        })}
                    </tbody>
                </Table>

            </div>
        );
    }
}
export default (Listaprecio);